export default __webpack_public_path__ + "static/media/loginImage.5f2343e8.jpeg";